import Row from "react-bootstrap/Row";

const FormBlock = ({ children, label = null, className = "" }) => {
  return (
    <div
      className={`form-block bg-white text-start position-relative ${className}`}>
      {label ? (
        <h3 className="mb-4 font-size-16 font-size-md-24 position-relative">
          {label}
        </h3>
      ) : null}
      <Row className="form-block-contents">{children}</Row>
    </div>
  );
};

export default FormBlock;
